import { useEffect, useMemo, useState } from 'react';
import { getViolationRuleCatalog } from '../../../services/violations';

/*
 * Метрики для gantt-v2 (§19.2: «zone/metric»). Параметр metric обязателен, и
 * выдумывать его список нельзя — он приходит из каталога камеры.
 *
 * Каталог лежит на админском роуте, поэтому обычной роли он может быть закрыт
 * (403). Это не ломает вкладку: остаётся метрика по умолчанию, а подпись честно
 * говорит, что полный список недоступен.
 *
 * Каталог запрашивается не для всех выбранных камер, а для первых
 * CATALOG_LIMIT: метрики определяются типом камеры, и полный обход выбранной
 * ветви ради выпадающего списка — это тот самый request storm из §19.2.
 */

const CATALOG_LIMIT = 3;

export const DEFAULT_GANTT_METRIC = 'people_count';

const FALLBACK_OPTIONS = [{ metric: DEFAULT_GANTT_METRIC, display_name: 'Количество людей' }];

export const useGanttMetrics = (cameraIds) => {
  const [state, setState] = useState({ options: FALLBACK_OPTIONS, status: 'idle' });
  const key = (cameraIds || []).slice(0, CATALOG_LIMIT).join(',');

  useEffect(() => {
    const ids = key ? key.split(',') : [];
    if (ids.length === 0) {
      setState({ options: FALLBACK_OPTIONS, status: 'idle' });
      return undefined;
    }
    let cancelled = false;
    setState((prev) => ({ options: prev.options, status: 'loading' }));
    Promise.all(ids.map((id) => getViolationRuleCatalog(id).then(
      (data) => data?.metrics || [],
      () => null
    ))).then((results) => {
      if (cancelled) return;
      const failed = results.filter((result) => result === null);
      if (failed.length === results.length) {
        setState({ options: FALLBACK_OPTIONS, status: 'restricted' });
        return;
      }
      const byMetric = new Map();
      results.filter(Boolean).forEach((metrics) => {
        metrics.forEach((item) => {
          if (item?.metric && !byMetric.has(item.metric)) byMetric.set(item.metric, item);
        });
      });
      const options = [...byMetric.values()];
      setState({
        options: options.length ? options : FALLBACK_OPTIONS,
        status: options.length ? 'ready' : 'empty',
      });
    });
    return () => { cancelled = true; };
  }, [key]);

  return useMemo(() => state, [state]);
};

export default useGanttMetrics;
